import React from 'react'
import Appstore from '../assets/Appstore.png'
import Playstore from '../assets/PlayStore.png'
import home from '../assets/home.jpg'
import calendar from '../assets/calendar.jpg'
import language from '../assets/language.jpg'
import places from '../assets/places.jpg'

const PlaystoreLogo = (props) => {
  return (
    <>
      <img src={Playstore} width={200} height={60} alt={'playstore logo'} {...props} />
    </>
  )
}
const AppstoreLogo = (props) => {
  return (
    <>
      <a href={props.href} target="blank">
        <img src={Appstore} width={200} height={60} alt={'appstore logo'} {...props} />
      </a>
    </>
  )
}
const ScreenshotHome = (props) => {
  return (
    <>
      <img src={home} width={207} height={448} alt={'appstore logo'} {...props} />
    </>
  )
}
const ScreenshotLanguage = (props) => {
  return (
    <>
      <img src={language} width={207} height={448} alt={'appstore logo'} {...props} />
    </>
  )
}
const ScreenshotCalendar = (props) => {
  return (
    <>
      <img src={calendar} width={207} height={448} alt={'appstore logo'} {...props} />
    </>
  )
}
const ScreenshotPlaces = (props) => {
  return (
    <>
      <img src={places} width={207} height={448} alt={'appstore logo'} {...props} />
    </>
  )
}
export { PlaystoreLogo, AppstoreLogo, ScreenshotHome, ScreenshotLanguage, ScreenshotCalendar, ScreenshotPlaces }